import {
    createBrowserRouter,
} from 'react-router-dom';

/*** 引入路由界面 ***/
import App from '../App.js';
import Error404 from './Error404.js';
/*** 引入路由界面 ***/

const BasicRouter = createBrowserRouter([
    {
        path: '/',
        element: <App m={11} />,
        errorElement: <Error404 />,
    }, {
        path: '/projects/bases',
        element: <App m={11} />,
        errorElement: <Error404 />,
    }, {
        path: '/projects/details',
        element: <App m={12} />,
        errorElement: <Error404 />,
    }, {
        path: '/projects/offers',
        element: <App m={13} />,
        errorElement: <Error404 />,
    }, {
        path: '/projects/progressLogs',
        element: <App m={14} />,
        errorElement: <Error404 />,
    }, {
        path: '/projects/repayments',
        element: <App m={15} />,
        errorElement: <Error404 />,
    }, {
        path: '/cars',
        element: <App m={21} />,
        errorElement: <Error404 />,
    }, {
        path: '/cars/repairs',
        element: <App m={22} />,
        errorElement: <Error404 />,
    }, {
        path: '/cars/oils',
        element: <App m={23} />,
        errorElement: <Error404 />,
    }, {
        path: '/cars/mileages',
        element: <App m={24} />,
        errorElement: <Error404 />,
    }, {
        path: '/wos',
        element: <App m={31} />,
        errorElement: <Error404 />,
    }, {
        path: '/wos/visits',
        element: <App m={32} />,
        errorElement: <Error404 />,
    }, {
        path: '/wos/dousers',
        element: <App m={33} />,
        errorElement: <Error404 />,
    }, {
        path: '/logs/operations',
        element: <App m={41} />,
        errorElement: <Error404 />,
    },
]);

export default BasicRouter